import { render } from "./addModuleNotice.vue?vue&type=template&id=17122c7a"
import script from "./addModuleNotice.vue?vue&type=script&lang=js"
export * from "./addModuleNotice.vue?vue&type=script&lang=js"

import "./addModuleNotice.vue?vue&type=style&index=0&id=17122c7a&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__